/* global Headers, setTimeout, clearTimeout, window, fetch, console */
/* eslint no-param-reassign: ["error", { "props": false }]*/

import polyfill from '../utils/polyfill';
import status from '../utils/status';

import timelineController from './timeline-controller';

let pollingTimer;

/**
 * Makes a request to update data
 *
 * @param  {Element} rootElement The component root node
 * @param  {Object} config The component configuration
 */
function requestData(rootElement, config) {
  if (!rootElement.dataset.url || !rootElement.dataset.interval) {
    return;
  }
  const auth = rootElement.getAttribute('data-url-auth');
  const headers = new Headers();

  if (auth) {
    headers.append('Authorization', auth);
  }

  fetch(rootElement.dataset.url, { headers })
    .then(status)
    .then(response => response.json())
    .then(timelineController.bind(null, rootElement, config))
    /* eslint-disable no-console */
    .catch(error => console.error(error));
    /* eslint-enable */

  pollingTimer = setTimeout(requestData.bind(null, rootElement, config), parseInt(rootElement.dataset.interval, 10) * 1000);
}

/**
 * Set up an event listener to handle stop/start polling on active window
 *
 * @param  {Element} rootElement The component root node
 * @param  {Object} config The component configuration
 */
function visibilityListener(rootElement, config) {
  if (typeof document.visibilityState !== 'undefined') { // Check browser supports visibilityState API
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        requestData(rootElement, config);
      } else {
        clearTimeout(pollingTimer); // Page is inactive, stop polling
      }
    }, false);
  }
  requestData(rootElement, config);
}

/**
 * Makes requests to update data (polyfills the fetch api if not available)
 *
 * @param  {Element} rootElement The component root node
 * @param  {Object} config The component configuration
 */
export default function(rootElement, config) {
  if (!rootElement || !config || !config.fetchPolyfill) {
    return;
  }

  polyfill('fetch' in window && Array.from && Array.prototype.includes, config.fetchPolyfill, () => {
    visibilityListener(rootElement, config);
  });
}
